/**
 * Type guard to check if a value is a non-null object record.
 *
 * @param obj - The value to check
 * @returns True if the value is an object record
 */
export const isObjectRecord = (obj: unknown): obj is object => {
  return typeof obj === "object" && obj !== null;
};
